import React, { Component } from "react";
import { Form, Button } from "react-bootstrap";
import LoginDesc from "./LoginDesc";
import { bindActionCreators } from "redux";
import { PASSWORD_VALIDATE } from "../../validation";
import {
  userResetPassword,
  userSecurityKey,
  validateUserForResetPassAction
} from "../../actions/login.action";
import { withRouter } from "react-router-dom";
import { ERROR_MSG, PATHS } from "../../constant";
import { toast } from "react-toastify";
import ReCaptcha from "../GoogleCaptcha/googleCaptcha";
import { get } from "lodash";
import { JSEncrypt } from "jsencrypt/lib";
import { connect } from "react-redux";
import { successToastStyle, errorToastStyle } from "../../customToast";

class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newPassword: "",
      confirmPassword: "",
      passwordMatched: false,
      errors: {}
    };
  }

  componentDidMount = async () => {
    const { history } = this.props;
    const token = this.getToken();
    try {
      const response = await validateUserForResetPassAction(undefined, {
        resetToken: token
      });
      if (response) {
        const { data } = response;
        const { status, message } = data;
        if (status) {
          this.setState({
            isUserValid: true
          });
        } else {
          toast.error(
            <p className="toast-text-alignment">{message}</p>,
            errorToastStyle
          );
          history.push(PATHS.LOGIN);
        }
      } else {
        toast.error(
          <p className="toast-text-alignment">
            {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
          </p>,
          errorToastStyle
        );
        history.push(PATHS.LOGIN);
      }
    } catch (error) {
      console.log("ERROR MSG While Reset Password -:", error.message);
    }
  };

  // get token
  getToken = () => {
    const {
      history: { location }
    } = this.props;
    return (
      location.pathname &&
      location.pathname.substr(location.pathname.lastIndexOf("/") + 1)
    );
  };

  handleChange = event => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  validateField = (fieldName, value) => {
    let { errors, newPassword, confirmPassword } = this.state;
    switch (fieldName) {
      case "newPassword":
        errors.newPassword = PASSWORD_VALIDATE(value);
        break;
      case "confirmPassword":
        errors.confirmPassword = PASSWORD_VALIDATE(value, newPassword);
        break;
      default:
        errors.newPassword = PASSWORD_VALIDATE(newPassword);
        errors.confirmPassword = PASSWORD_VALIDATE(confirmPassword);
        break;
    }
    this.setState({
      errors: errors
    });
  };

  validateForm = () => {
    let { errors } = this.state;
    let { newPassword, confirmPassword } = errors;
    return (
      (newPassword.error && confirmPassword.error) !== undefined &&
      !newPassword.error &&
      !confirmPassword.error
    );
  };

  submitResetForm = async event => {
    //event.preventDefault();
    const { encryptedPassword, userID } = this.state;
    const { history } = this.props;
    const token = this.getToken();
    const resetInfo = { token, newPassword: encryptedPassword, key: userID };

    this.validateField();
    let isValidData = this.validateForm();
    if (isValidData) {
      try {
        const resp = await userResetPassword(undefined, resetInfo);
        if (resp) {
          const { data } = resp;
          const { status, message } = data || {};
          if (status) {
            toast.success(
              <p className="toast-text-alignment">{message}</p>,
              successToastStyle
            );
            history.push(PATHS.LOGIN);
          } else {
            toast.error(
              <p className="toast-text-alignment">{message}</p>,
              errorToastStyle
            );
            history.push(PATHS.LOGIN);
          }
        } else {
          toast.error(
            <p className="toast-text-alignment">
              {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
            </p>,
            errorToastStyle
          );
        }
      } catch (e) {
        console.log(`Error : ${e.message}`);
      }
    }
  };

  getSecurityKey = async () => {
    const { captchaToken, newPassword } = this.state;
    const { userSecurityKey } = this.props;
    try {
      await userSecurityKey();
      const { securityKeyData, history } = this.props;
      if (get(securityKeyData, "id")) {
        let userID = get(securityKeyData, "id");
        const encrypt = new JSEncrypt();
        encrypt.setPublicKey(get(securityKeyData, "key"));
        const encryptedPassword = encrypt.encrypt(newPassword);
        this.setState({ encryptedPassword, userID });
        this.submitResetForm();
      } else {
        toast.error(
          <p className="toast-text-alignment">Please check your credentials</p>,
          errorToastStyle
        );
        //history.push(PATHS.SIGNUP);
      }
      this.captchaElement &&
        this.captchaElement.reset(this.captchaElementResetId);
    } catch (e) {
      console.log(`Error in Reset Password ${e.message}`);
    }
  };

  onCaptchaResolved = captchaToken => {
    this.setState({ captchaToken });
    (captchaToken && this.getSecurityKey()) ||
      toast.error(
        <p className="toast-text-alignment">{ERROR_MSG.INVALID_CAPTCHA}</p>,
        errorToastStyle
      );
  };

  onValidateCaptcha = event => {
    event.preventDefault();
    this.validateField();
    let isValidData = this.validateForm();
    if (isValidData && this.captchaElement) {
      this.captchaElement.execute(this.captchaElementResetId);
    }
  };

  checkForMatched = confirmPassword => {
    let { newPassword } = this.state;
    this.setState({
      passwordMatched: confirmPassword && confirmPassword === newPassword
    });
  };

  render() {
    const {
      newPassword,
      confirmPassword,
      errors,
      isUserValid,
      passwordMatched
    } = this.state;
    // Do not render
    if (!isUserValid) {
      return null;
    }
    return (
      <React.Fragment>
        <div className="signup user-login">
          <div className="register-outer">
            <div className="register-inner">
              <h1 className="page-heading">Reset Password</h1>
              <Form className="reset-form">
                <div className="userId">
                  <Form.Group controlId="newPwd">
                    <Form.Label>New Password</Form.Label>
                    <Form.Control
                      name="newPassword"
                      type="password"
                      value={newPassword}
                      onChange={this.handleChange}
                      onBlur={() => {
                        this.validateField("newPassword", newPassword);
                        this.checkForMatched(confirmPassword);
                      }}
                      isInvalid={errors.newPassword && errors.newPassword.error}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.newPassword && errors.newPassword.error
                        ? errors.newPassword.message
                        : null}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group controlId="confirmPwd">
                    <Form.Label>Confirm Password</Form.Label>
                    <Form.Control
                      name="confirmPassword"
                      type="password"
                      value={confirmPassword}
                      onChange={this.handleChange}
                      onBlur={() => {
                        this.validateField("confirmPassword", confirmPassword);
                        this.checkForMatched(confirmPassword);
                      }}
                      isInvalid={
                        errors.confirmPassword && errors.confirmPassword.error
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.confirmPassword && errors.confirmPassword.error
                        ? errors.confirmPassword.message
                        : null}
                    </Form.Control.Feedback>
                    {passwordMatched ? (
                      <span className="password-matched">Password Matched</span>
                    ) : null}
                  </Form.Group>
                </div>
                <Button
                  variant="primary"
                  type="submit"
                  className="btn-orange full-width"
                  onClick={this.onValidateCaptcha}
                >
                  Submit
                </Button>
                <ReCaptcha
                  id="recaptcha-4"
                  getRef={ref => {
                    this.captchaElement = ref;
                  }}
                  onChange={this.onCaptchaResolved}
                  resetId={id => {
                    this.captchaElementResetId = id;
                  }}
                />
              </Form>
            </div>
          </div>
          <div className="no-account">
            <LoginDesc
              accountHeading="Have an account?"
              accountSubHead="Login Now"
              buttonText="Login"
              buttonLink="/login"
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    securityKeyData: state.loginReducer.securityKeyData
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      userSecurityKey
    },
    dispatch
  );
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ResetPassword)
);
